// Display only: the existing package/gift identities, receipts and eligibility stay intact.
export function newbieDisplaySections(model) {
  const gifts = Array.isArray(model.gifts) ? model.gifts : [];
  const tasks = Array.isArray(model.tasks) ? model.tasks : [];
  const sections = gifts.map((gift, index) => ({
    kind: 'gift', key: gift.key, gift,
    sortNo: Number.isSafeInteger(gift.sortNo) ? gift.sortNo : Infinity,
    index: index + 1
  }));
  if (!gifts.length || model.package?.enabled || tasks.length > 0) {
    sections.unshift({
      kind: 'registration', key: '_package',
      sortNo: Number.isSafeInteger(model.registrationSortNo) && model.registrationSortNo > 0
        ? model.registrationSortNo : 1,
      index: 0
    });
  }
  return sections.sort((left, right) => left.sortNo - right.sortNo || left.index - right.index);
}
